import api from "../../services/axiosConfig";
import createModuleApi from "../../services/createModuleApi";

const crud = createModuleApi("/instances/governeye/dghelper");

export const fetchUsers = crud.fetchAll;
export const createUser = crud.create;
export const updateUser = crud.update;
export const deleteUser = crud.remove;

export const fetchRoles = async () => {
  const res = await api.get("/instances/governeye/dghelper/list-roles", {
    data: {},
  });
  return res.data.data.roles;
};

export const fetchPermissions = async () => {
  const res = await api.get("/instances/governeye/dghelper/list-permissions", {
    data: {},
  });
  return res.data.data.permissions;
};

export const grantPermission = async (userId, permissionId) => {
  const res = await api.post("/instances/governeye/dghelper/grant-permission", {
    userId,
    permissionId,
  });
  return res.data;
};

export const revokePermission = async (userId, permissionId) => {
  const res = await api.post(
    "/instances/governeye/dghelper/revoke-permission",
    { userId, permissionId },
  );
  return res.data;
};

export const changeUserRole = async (userId, newRole) => {
  const role = newRole.startsWith("ROLE_") ? newRole.substring(5) : newRole;
  const res = await api.put(
    `/instances/governeye/dghelper/change-user-role/${userId}`,
    null,
    { params: { role } },
  );
  if (res.data?.data?.exception || res.data?.data?.statusCode >= 400) {
    throw new Error(res.data?.data?.exception || "Failed to update role");
  }
  return res.data;
};
